<div class="latest-comments-section">
  <div class="d-flex justify-content-between align-items-center">
    <h5>Comments</h5>
  </div>

  <hr />

  <!--Add New Comment Section (moved above comments) -->
  <div class="row mb-3 align-items-start">
    <div class="col-md-10 mb-2">
      <textarea class="form-control" [(ngModel)]="newComment" placeholder="{{ newCommentPlaceHolder }}" rows="3"></textarea>
    </div>
    <div class="col-md-10 mt-0">
      <button type="submit" class="btn btn-primary" [disabled]="!isValidComment()" (click)="saveNewComment()">
        Submit
      </button>
    </div>
  </div>

  <!-- Comments Display -->
  <div class="communication-modal" *ngIf="comments && comments.length > 0">
    <div *ngFor="let comment of comments">
      <b>{{ comment.By }}</b>
      <p class="text-muted small mb-1 d-flex align-items-center" style="gap: 0.5em;">
        {{ comment.At | date: 'medium' }}
        <span class="badge bg-secondary text-white" style="font-size: 0.75em;">v{{ comment.Version }}</span>
      </p>
      <div [innerHTML]="comment.Comment?.replace('\n', '<br />')"></div>
      <hr />
    </div>
  </div>
  <!-- Empty state message -->
<div class="alert alert-light text-center" *ngIf="!comments || comments.length === 0">
  No comments available.
</div>

</div>
